import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg404DoorAndConfusedPenguin = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 920.1782 677",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("style", { children: "\n      .st0, .st1, .st2, .st3, .st4, .st5, .st6 {\n        fill: none;\n      }\n\n      .st7 {\n        fill: #0075c7;\n      }\n\n      .st8 {\n        fill: #006ca7;\n      }\n\n      .st9 {\n        fill: #003343;\n      }\n\n      .st10 {\n        mix-blend-mode: multiply;\n        opacity: .17;\n      }\n\n      .st11 {\n        fill: #73ccf4;\n      }\n\n      .st12 {\n        fill: #ffba40;\n      }\n\n      .st13 {\n        fill: #def2ff;\n      }\n\n      .st14 {\n        fill: #f48d2e;\n      }\n\n      .st1 {\n        stroke-width: 4px;\n      }\n\n      .st1, .st2, .st3, .st4 {\n        stroke-linecap: round;\n      }\n\n      .st1, .st2, .st3, .st4, .st5 {\n        stroke-miterlimit: 10;\n      }\n\n      .st1, .st6 {\n        stroke: #020202;\n      }\n\n      .st2 {\n        stroke-width: 2.0655px;\n      }\n\n      .st2, .st3 {\n        stroke: #00b6e0;\n      }\n\n      .st15 {\n        isolation: isolate;\n      }\n\n      .st16 {\n        fill: #e2f8ff;\n      }\n\n      .st17, .st18 {\n        fill: #fff;\n      }\n\n      .st19 {\n        fill: #ade7ff;\n      }\n\n      .st20 {\n        fill: #ffbe4f;\n      }\n\n      .st21 {\n        opacity: .32;\n      }\n\n      .st22 {\n        fill: #bbe5ff;\n      }\n\n      .st23 {\n        fill: #282828;\n      }\n\n      .st24 {\n        fill: #53c891;\n      }\n\n      .st3 {\n        stroke-width: 6px;\n      }\n\n      .st25 {\n        fill: #003f99;\n        opacity: .11;\n      }\n\n      .st18 {\n        font-family: Comfortaa-SemiBold, Comfortaa;\n        font-size: 76.6236px;\n        font-weight: 600;\n      }\n\n      .st4 {\n        stroke: #000;\n        stroke-width: 4.0841px;\n      }\n\n      .st26 {\n        clip-path: url(#clippath);\n      }\n\n      .st5 {\n        stroke: #e2f8ff;\n        stroke-width: 2.4293px;\n      }\n\n      .st6 {\n        stroke-linejoin: round;\n        stroke-width: .6054px;\n      }\n\n      .st27 {\n        fill: #007e4b;\n      }\n    " }), /* @__PURE__ */ _jsx("clipPath", {
			id: "clippath",
			children: /* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M615.8775,337.5988c-6.4382,17.0301-21.6329,26.6907-33.9381,21.5775-12.3053-5.1132-17.0615-23.0639-10.6233-40.094,6.4382-17.0301,21.6329-26.6907,33.9381-21.5775,12.3053,5.1132,17.0615,23.0639,10.6233,40.094Z"
			})
		})] }),
		/* @__PURE__ */ _jsx("g", {
			className: "st15",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Layer_1",
				children: [
					/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
						className: "st7",
						x: 568.2809,
						y: 171.8521,
						width: 21.922,
						height: 21.922,
						transform: "translate(169.0102 -265.1286) rotate(30)"
					}), /* @__PURE__ */ _jsx("rect", {
						className: "st11",
						x: 517.4409,
						y: 127.4734,
						width: 21.922,
						height: 21.922,
						transform: "translate(140.0097 -245.6543) rotate(30)"
					})] }),
					/* @__PURE__ */ _jsx("ellipse", {
						className: "st25",
						cx: 647.9279,
						cy: 581.8918,
						rx: 162.3663,
						ry: 27.4449
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "st8",
						d: "M227.2408,539.6843l210.0247-12.3228c8.7718-.5147,15.615-7.7899,15.5923-16.5768l-1.0959-424.5348c-.0242-9.3687-7.8078-16.8524-17.1702-16.5085l-250.8128,9.211c-9.5373.3503-16.806,8.6674-15.8757,18.1657l41.8841,427.6467c.8671,8.8534,8.5732,15.4406,17.4537,14.9196Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "st25",
						d: "M646.8384,526.4443H116.735c-4.3309,0-5.8334,5.7565-2.0551,7.8732l61.671,34.5484c.7196.4031,1.5418.5857,2.3643.525l468.4324-34.5484c5.3891-.3975,5.0945-8.3982-.3093-8.3982Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "st13",
						d: "M440.8651,528.3245l-251.5514,39.3063c-6.5775,1.0278-12.7615-3.4163-13.8848-9.9782L99.7866,115.7657c-1.1466-6.6982,3.4102-13.039,10.1243-14.0881l257.9884-40.3112c6.6457-1.0384,12.8749,3.5072,13.9133,10.1529l69.2053,442.8918c1.0384,6.6457-3.5072,12.875-10.1529,13.9134Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "st6",
						d: "M421.2708,500.1628l-223.0022,34.8483-68.9397-405.1442,218.4317-34.1289c5.5603-.8688,10.7721,2.9344,11.6409,8.4947l61.8693,395.9301Z"
					}),
					/* @__PURE__ */ _jsx("polygon", {
						className: "st7",
						points: "421.2708 500.1628 198.2687 535.0111 129.3289 129.8669 204.6619 525.2819 421.2708 500.1628"
					}),
					/* @__PURE__ */ _jsx("polygon", {
						className: "st19",
						points: "381.67 320.0005 358.6578 323.1245 345.0236 254.7418 370.845 250.7036 381.67 320.0005"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "st8",
						d: "M367.5454,280.1091l2.4943,5.1098c1.4107,2.8939-.0121,6.3751-3.0453,7.4467l-13.4586,4.7586-2.7729-13.9187,16.7884-3.3964h-.006Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "st19",
						d: "M309.6668,295.7593l53.2592-9.2085c3.0392-.5267,5.0977-3.3904,4.6194-6.4417h0c-.4541-2.9182-3.0877-4.9948-6.03-4.7586l-51.9697,4.1471.1211,16.2617h0Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "st17",
						d: "M169.3756,302.5037v-13.392l51.9636-4.1471c.1453-.0121.3027-.0182.448-.0182,2.7547,0,5.1582,2.004,5.5881,4.7829,0,0-.8536-2.2098-4.1956-1.9676-2.2945.1635-48.4824,5.9695-48.4824,5.9695l-5.3277,8.7787.0061-.0061Z"
					}),
					/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("path", {
							className: "st11",
							d: "M597.2374,493.2852c-17.9895-33.4755-15.1256-69.0182-10.2228-92.9157.8724-4.2769,1.8113-8.1745,2.7027-11.6263,0,0,6.6097-14.3575,19.9999-27.7476,13.3807-13.3807,14.1014-29.1227,0-32.347-6.9606-1.5932-45.7751,3.5372-45.7751,3.5372,0,0-7.6719,2.2096-10.1185,2.257,1.1285-8.0796,3.0725-16.5386,6.1356-25.1303,7.0365-19.7628,46.2587-65.2534,110.0517-62.8257,63.793,2.4372,95.2106,27.5864,110.3742,73.2572,14.4523,43.5371-4.4855,64.8551-4.4855,64.8551,0,0,39.2317,57.6574,41.1758,97.0978,1.9535,39.4403,14.1204,93.4942,22.3992,105.6705s-45.282-6.3252-55.0211-11.6832c-3.5751,1.1664-8.5633,2.3518-14.5471,3.5182h-.0095c-13.8074,2.7027-32.8685,5.2916-51.8253,7.2072-24.3622,2.4656-48.5442,3.8312-61.2041,2.9113-3.9071-.2845-8.3736-.7112-13.1816-1.3276-.3035-.0474-.6164-.0853-.9293-.1138-3.6415-.4742-7.4632-1.0431-11.3892-1.7354l.0284-.1422c-13.6462-14.1678-36.1118-50.052-34.1582-92.7166Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "st14",
							d: "M769.9062,579.2024c5.7373,3.5467,20.4077,19.0895-.0095,18.6533-20.4172-.4267-51.8253-11.4461-51.8253-11.4461,18.9568-1.9156,38.0179-4.5045,51.8253-7.2072h.0095Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "st14",
							d: "M643.6858,587.9932c13.6652,1.9346,23.9923,15.2868-4.8933,14.7463-29.54-.55-18.8809-9.6159-41.0809-6.6761-22.2,2.9398-41.8396,4.8174-22.6552-7.7857-11.7496-6.4201-15.2489-17.3352,7.0555-19.0326,13.1152,8.6391,32.0909,13.8738,49.2554,16.8989,3.926.6923,7.7477,1.2613,11.3892,1.7354.3129.0284.6259.0664.9293.1138Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "st22",
							d: "M631.3956,586.0018l-.0284.1422c-17.1645-3.0251-36.1402-8.2598-49.2554-16.8989-7.0175-4.6183-12.3565-10.2038-14.8506-16.9369-9.7392-26.2967-21.4224-110.0517-6.8184-151.9387h26.5717c-4.9028,23.8975-7.7667,59.4403,10.2228,92.9157-1.9535,42.6646,20.512,78.5488,34.1582,92.7166Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "st12",
							d: "M609.7172,328.6485c14.1014,3.2243,13.3807,18.9663,0,32.347-13.3902,13.3902-19.9999,27.7476-19.9999,27.7476-.8914,3.4519-1.8302,7.3494-2.7027,11.6263h-.0095c-30.2796-14.4144-26.9605-1.3276-26.5907-.0948-.7302-1.8397-11.5599-30.2607-6.5908-65.8319,2.4466-.0474,10.1185-2.257,10.1185-2.257,0,0,38.8145-5.1304,45.7751-3.5372Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "st22",
							d: "M587.0051,400.3695h-26.5623s-.0095-.0284-.0284-.0948c-.3698-1.2328-3.6889-14.3195,26.5907.0948Z"
						})
					] }), /* @__PURE__ */ _jsx("path", {
						className: "st2",
						d: "M642.5193,459.5158s45.5001,89.3216,44.3811,101.6781c-1.1285,12.3565-24.7225,4.495-69.6631-41.0051-7.8805-7.9848-14.073-16.3584-18.8809-24.8743"
					})] }),
					/* @__PURE__ */ _jsx("path", {
						className: "st11",
						d: "M563.9398,449.993v21.2232s1.6188,11.6519,11.6061,11.6519,12.5488-12.1683,12.5488-12.1683c0,0-4.1283-17.0029-3.9991-20.7068h-20.1558Z"
					}),
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
							className: "st17",
							d: "M605.2445,297.506c12.317,5.1181,17.0693,23.063,10.6343,40.0911-6.448,17.0268-21.6443,26.695-33.9483,21.5782-6.2897-2.6276-10.6087-8.5872-12.4645-16.0841,2.0915,5.196,5.8497,8.7725,10.7365,9.4802,9.5779,1.3952,19.8343-8.7348,22.9181-22.6045,3.0838-13.8697-2.1786-26.2424-11.7434-27.6363-4.7432-.6929-9.647,1.4415-13.7648,5.4636,7.5648-9.6531,18.4111-14.129,27.6322-10.2882Z"
						}), /* @__PURE__ */ _jsx("path", {
							className: "st23",
							d: "M591.3772,302.3306c9.5648,1.3938,14.8272,13.7666,11.7434,27.6363-3.0838,13.8697-13.3402,23.9996-22.9181,22.6045-4.8869-.7077-8.6451-4.2842-10.7365-9.4802-1.7753-7.143-1.3002-15.6882,1.8433-24.0056,1.6096-4.2648,3.776-8.0637,6.3031-11.2913,4.1178-4.0221,9.0216-6.1565,13.7648-5.4636Z"
						})] }),
						/* @__PURE__ */ _jsx("g", {
							className: "st26",
							children: /* @__PURE__ */ _jsx("g", {
								className: "st10",
								children: /* @__PURE__ */ _jsx("path", {
									className: "st9",
									d: "M569.2628,320.249s4.2057-8.6479,22.215.2978c16.1275,8.0109,24.8287,26.7262,24.8287,26.7262,0,0,15.0652-39.1229-8.727-51.0996-25.7691-12.9718-38.3167,24.0756-38.3167,24.0756Z"
								})
							})
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "st17",
							d: "M585.8261,318.0927c-2.3807,3.8128-5.7699,5.658-7.57,4.1214-1.8001-1.5366-1.3293-5.873,1.0514-9.6858,2.3807-3.8128,5.7699-5.658,7.57-4.1214s1.3293,5.873-1.0514,9.6858Z"
						})
					] }),
					/* @__PURE__ */ _jsx("path", { d: "M560.8528,328.4348c7.7277,0,8.7692,6.0703,6.5853,29.9515,0,0-.1344-3.8893-14.0106-4.2165-13.8762-.2908-32.7922-8.7601-32.7922-8.7601-8.3324.4725-18.7816.2544-8.0636-6.6882,11.5579-7.4879,22.5782-10.3231,48.2811-10.2867Z" }),
					/* @__PURE__ */ _jsx("path", {
						className: "st4",
						d: "M614.1317,267.8815c-.335,5.025.67,16.7501,13.7351,24.4552"
					}),
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("path", {
							className: "st7",
							d: "M616.0108,287.0587c-.0931,0-.187-.0088-.2808-.0268l-26.001-4.9601c-.5884-.1123-1.113-.5665-1.4772-1.2792-.3639-.7126-.5237-1.5982-.4499-2.4938l1.7523-21.2689c.1522-1.8485,1.2618-3.1649,2.4794-2.9325l26.001,4.9602c.5886.1123,1.113.5666,1.4772,1.2792.3639.7126.5237,1.5982.4499,2.4938l-1.7523,21.2689c-.0738.8956-.3722,1.6939-.8405,2.2476-.3937.4655-.8677.7115-1.3582.7115ZM591.7573,257.1637c-.0934,0-.1748.1061-.1867.2509l-1.7523,21.2689c-.0111.1341.0753.3032.1635.32l26.001,4.9601c.0886.0174.1993-.1147.2104-.2486l1.7523-21.2689c.0111-.1341-.0753-.3032-.1635-.32l-26.001-4.9602c-.008-.0015-.0159-.0022-.0237-.0022Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "st7",
							d: "M616.0108,287.0587c-.0931,0-.187-.0088-.2808-.0268l-26.001-4.9601c-.5884-.1123-1.113-.5665-1.4772-1.2792-.3639-.7126-.5237-1.5982-.4499-2.4938l1.7523-21.2689c.1522-1.8485,1.2618-3.1649,2.4794-2.9325l26.001,4.9602c.5886.1123,1.113.5666,1.4772,1.2792.3639.7126.5237,1.5982.4499,2.4938l-1.7523,21.2689c-.0738.8956-.3722,1.6939-.8405,2.2476-.3937.4655-.8677.7115-1.3582.7115ZM591.7573,257.1637c-.0934,0-.1748.1061-.1867.2509l-1.7523,21.2689c-.0111.1341.0753.3032.1635.32l26.001,4.9601c.0886.0174.1993-.1147.2104-.2486l1.7523-21.2689c.0111-.1341-.0753-.3032-.1635-.32l-26.001-4.9602c-.008-.0015-.0159-.0022-.0237-.0022Z"
						}),
						/* @__PURE__ */ _jsx("g", {
							className: "st21",
							children: /* @__PURE__ */ _jsx("path", {
								className: "st17",
								d: "M616.3303,285.5882l-26.9486-5.1409c-.3983-.076-.6808-.629-.6308-1.2351l1.871-22.7108c.0499-.6062.4133-1.036.8117-.96l26.9486,5.1409c.3983.076.6808.629.6308,1.2351l-1.871,22.7108c-.0499.6062-.4133,1.036-.8117.96Z"
							})
						})
					] }),
					/* @__PURE__ */ _jsx("rect", {
						className: "st7",
						x: 584.9102,
						y: 332.0955,
						width: 7.6707,
						height: 7.6707,
						transform: "translate(246.8424 -249.3666) rotate(30)"
					}),
					/* @__PURE__ */ _jsx("polyline", {
						className: "st1",
						points: "140.4971 96.8985 207.5506 218.4708 70.5516 218.4708 106.9623 157.6846"
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "st20",
						x: 45.9498,
						y: 215.1733,
						width: 183.5501,
						height: 96.0278,
						rx: 3.0375,
						ry: 3.0375
					}),
					/* @__PURE__ */ _jsx("text", {
						className: "st18",
						transform: "translate(64.5671 294.1271)",
						children: /* @__PURE__ */ _jsx("tspan", {
							x: 0,
							y: 0,
							children: "404"
						})
					}),
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("polygon", {
							className: "st27",
							points: "793.0285 92.5469 775.9591 177.9208 771.3616 169.7924 788.431 84.4185 793.0285 92.5469"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							className: "st27",
							points: "771.3616 169.7924 775.9591 177.9208 690.5748 160.8493 685.9877 152.723 771.3616 169.7924"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "st24",
							d: "M788.431,84.4185l-17.0694,85.3739-85.3739-17.0694,17.0694-85.3739,85.3739,17.0694ZM765.2484,160.6238l14.014-70.0921-70.0921-14.014-14.014,70.0921,70.0921,14.014Z"
						}),
						/* @__PURE__ */ _jsx("rect", {
							className: "st17",
							x: 701.4697,
							y: 82.8311,
							width: 71.4793,
							height: 71.4793,
							transform: "translate(476.4048 818.2261) rotate(-78.6935)"
						})
					] }),
					/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("line", {
						className: "st3",
						x1: 721.5348,
						y1: 93.506,
						x2: 757.4814,
						y2: 143.6355
					}), /* @__PURE__ */ _jsx("line", {
						className: "st3",
						x1: 764.5728,
						y1: 100.5974,
						x2: 714.4433,
						y2: 136.5441
					})] })
				]
			})
		})
	]
});
const ForwardRef = forwardRef(Svg404DoorAndConfusedPenguin);
export default ForwardRef;
